module.exports = __webpack_public_path__ + "img/elem1Image.22db2765.png";